import API from 'types/api';
import _ from 'lodash';

const initialState = {};

export default (state = initialState, { type, payload, request }) => {
  switch (type) {
    case API.GET_VIDEO_INFO_FETCH:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          isLoading: true,
          isLoaded: false,
          isError: false,
        },
      };
    case API.GET_VIDEO_INFO_ERROR:
      return {
        ...state,
        [request.id]: {
          ...state[request.id],
          isLoading: false,
          isLoaded: true,
          isError: true,
        },
      };
    case API.GET_VIDEO_INFO_SUCCESS:
      const movie = _.get(payload, 'entities.movie');
      if (movie && movie[payload.result]) {
        return {
          ...state,
          [request.id]: {
            ...movie[payload.result],
            isLoading: false,
            isLoaded: true,
            isError: false,
          },
        };
      }
      return {
        ...state,
        [request.id]: {
          ...state[request.id],
          isLoading: false,
          isLoaded: true,
          isError: true,
        },
      };
    default:
      return state;
  }
};
